import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MetricsCards from './MetricsCards';
import ChartsComponent from './ChartsComponent';

const API_BASE = '';

function DashboardComponent({ vehicle }) {
  const [fullData, setFullData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (vehicle?.vin) {
      setLoading(true);
      axios.get(`${API_BASE}/api/vehicle/${vehicle.vin}`)
        .then(res => setFullData(res.data))
        .catch(err => { console.error(err); setFullData(null); })
        .finally(() => setLoading(false));
    }
  }, [vehicle?.vin]);

  if (!vehicle) return null;

  const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

  let make = fullData?.make || vehicle.make || '';
  let model = fullData?.model || vehicle.model || '';
  if (!make || !model) {
    const parts = (vehicle.vehicle_str || '').split(' ');
    make = parts[1] || 'Unknown';
    model = parts.slice(2).join(' ') || 'Unknown';
  }

  const formattedMake = make.split(' ').map(capitalize).join(' ');
  const formattedModel = model.split(' ').map(capitalize).join(' ');
  const displayYear = fullData?.year || vehicle.year || 'Unknown';

  const displayData = fullData || vehicle;

  return (
    <div className="dashboard-section">
      <h2>Selected: {displayYear} {formattedMake} {formattedModel}</h2>
      <p className="vin-display">VIN: <strong>{vehicle.vin}</strong></p>
      {loading ? <p>Loading details...</p> : (
        <>
          <MetricsCards vehicle={displayData} />
          <ChartsComponent vehicle={displayData} />
        </>
      )}
    </div>
  );
}

export default DashboardComponent;
